import { put, call, all, takeEvery } from 'redux-saga/effects'
import { store as reduxStore } from 'index'
import {
  get as callLogs,
  downloadRecording as downloadCallRecording,
  getByID as getCallDetail,
} from 'services/callLogs'
import {
  get as callLogsLegacy,
  downloadRecording as downloadCallRecordingLegacy,
  getParticipants as getCallSessionParticipants,
  getByID as getCallDetailLegacy,
} from 'services/callLogsLegacy'
import { getAppCallsHost, getAppMetricHost } from 'helpers'
import actions from './actions'

export function* GET_CALL_LOGS({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: { callSearchLogsLoading: true },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  try {
    const success = yield call(callLogs, activeApp, getAppCallsHost(appSettings), payload)

    if (success && success.data) {
      let totalCount = success.data.length
      let pagination = {}
      if (success.meta && success.meta.pagination) {
        totalCount = success.meta.pagination.total
        ;({ pagination } = success.meta)
      }
      yield put({
        type: actions.SET_STATE,
        payload: {
          callSearchLogs: success.data,
          callSearchLogsTotal: totalCount,
          callSearchLogsPagination: pagination,
          callSearchLogsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          callSearchLogs: [],
          callSearchLogsTotal: 0,
          callSearchLogsPagination: {},
          callSearchLogsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: { callSearchLogsLoading: false },
    })
    window.triggerNotification('Failed to fetch call logs', 'error')
  }
}

export function* GET_CALL_BY_ID({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: { callSearchLogsLoading: true },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  try {
    const success = yield call(getCallDetail, payload.id, activeApp, getAppCallsHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          callActive: success.data,
          callSearchLogsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: { callSearchLogsLoading: false },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: { callSearchLogsLoading: false },
    })
    window.triggerNotification('Failed to fetch call details', 'error')
  }
}

export function* GET_CALL_SESSION_PARTICIPANT_DETAILS({ payload }) {
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  try {
    const success = yield call(getCallSessionParticipants, payload.sessionId, activeApp, getAppMetricHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: { callSessionParticipants: success.data },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: { callSessionParticipants: [] },
      })
    }
  } catch (error) {
    window.triggerNotification('Failed to fetch session participants', 'error')
  }
}

export function* GET_CALL_LOGS_LEGACY({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: { callSearchLogsLoading: true },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  try {
    const success = yield call(callLogsLegacy, activeApp, getAppMetricHost(appSettings), payload)

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          callSearchLogsLegacy: success.data,
          callSearchLogsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: {
          callSearchLogsLegacy: [],
          callSearchLogsLoading: false,
        },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: { callSearchLogsLoading: false },
    })
    window.triggerNotification('Failed to fetch call logs', 'error')
  }
}

export function* GET_CALL_BY_ID_LEGACY({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: { callSearchLogsLoading: true },
  })

  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  try {
    const success = yield call(getCallDetailLegacy, payload.id, activeApp, getAppMetricHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: {
          callActiveLegacy: success.data,
          callSearchLogsLoading: false,
        },
      })
    } else {
      yield put({
        type: actions.SET_STATE,
        payload: { callSearchLogsLoading: false },
      })
    }
  } catch (error) {
    yield put({
      type: actions.SET_STATE,
      payload: { callSearchLogsLoading: false },
    })
    window.triggerNotification('Failed to fetch call details', 'error')
  }
}

export function* DOWNLOAD_CALL_RECORDING({ payload }) {
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  try {
    const success = yield call(downloadCallRecording, payload.sessionId, activeApp, getAppCallsHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: { callRecordings: success.data },
      })
    }
  } catch (error) {
    window.triggerNotification('Failed to download recording', 'error')
  }
}

export function* DOWNLOAD_CALL_RECORDING_LEGACY({ payload }) {
  const activeApp = reduxStore.getState().apps.active
  const { appSettings } = reduxStore.getState().apps

  try {
    const success = yield call(downloadCallRecordingLegacy, payload.sessionId, activeApp, getAppMetricHost(appSettings))

    if (success && success.data) {
      yield put({
        type: actions.SET_STATE,
        payload: { callRecordings: success.data },
      })
    }
  } catch (error) {
    window.triggerNotification('Failed to download recording', 'error')
  }
}

export default function* callsSaga() {
  yield all([
    takeEvery(actions.GET_CALL_LOGS, GET_CALL_LOGS),
    takeEvery(actions.GET_CALL_BY_ID, GET_CALL_BY_ID),
    takeEvery(actions.GET_CALL_SESSION_PARTICIPANT_DETAILS, GET_CALL_SESSION_PARTICIPANT_DETAILS),
    takeEvery(actions.GET_CALL_LOGS_LEGACY, GET_CALL_LOGS_LEGACY),
    takeEvery(actions.GET_CALL_BY_ID_LEGACY, GET_CALL_BY_ID_LEGACY),
    takeEvery(actions.DOWNLOAD_CALL_RECORDING, DOWNLOAD_CALL_RECORDING),
    takeEvery(actions.DOWNLOAD_CALL_RECORDING_LEGACY, DOWNLOAD_CALL_RECORDING_LEGACY),
  ])
}
